<ng-container *ngIf="!this.isWhiteLabel">
  <div class="searchForm__topButton" [class.searchForm__topButton__ricerca]="!this.isHome && !this.is404">
    <button class="agente"
      [class.topBtnActive]="this.main?.searchType == 'agente' || this.main?.searchType == 'agenzia' || this.main?.searchType === 'professionista' && this.main.searchMethodType == 'place'"
      (click)="handleClickOnProfessionistTab()"><img class="svg_icon" width="15" height="15"
        [ngSrc]="'assets/icons/prof_icon.svg'" alt="icona affitto">
      Professionisti
    </button>
    <button class="vendita" [class.topBtnActive]="this.main?.searchType == 'vendita'"
      (click)="this.setSearchQueryTypeTo('vendita')"><img class="svg_icon" width="15" height="15"
        [ngSrc]="'assets/icons/sell_icon.svg'" alt="icona vendita">
      Vendita
    </button>
    <button class="affitto" [class.topBtnActive]="this.main?.searchType == 'affitto'"
      (click)="this.setSearchQueryTypeTo('affitto')"><img class="svg_icon" width="15" height="15"
        [ngSrc]="'assets/icons/rent_icon.svg'" alt="icona affitto">
      Affitto
    </button>
  </div>
</ng-container>

<div [class.searchFormMain--open]="this.main?.searchDropdown || this.main?.searchDropdownCityZones"
  class="searchFormMain d-flex flex-column">
  <div *ngIf="this.main?.searchType !== 'vendita' && this.main?.searchType !== 'affitto'"
    class="searchFormMain__btnCont mb-2 d-flex">
    <ng-container
      *ngIf="(this.main?.searchType == 'agente' || this.main?.searchType == 'agenzia' || this.main?.searchType == 'professionista') && this.main.searchMethodType == 'name'">
      <div (click)="this.searchByName(true)" [class.btn--selected]="this.main.isAgentSearch" class="btn">{{
        this.isWhiteLabel ? 'Agenti immobiliari' :
        'Agenzie e agenti immobiliari'
        }}
      </div>
      <ng-container *ngIf="!this.isWhiteLabel">
        <div (click)="this.searchByName(false)" [class.btn--selected]="!this.main.isAgentSearch" class="btn ms-2">
          Consulenti del credito e
          assicurativo
        </div>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="(this.main?.searchType == 'agente' || this.main?.searchType == 'agenzia' || this.main?.searchType == 'professionista') && this.main.searchMethodType == 'place'">
      <ng-container *ngIf="!this.isWhiteLabel">
        <div (click)="this.searchByPlace('agente', true)"
          [class.btn--selected]="this.main.isAgentSearch && this.main?.searchType == 'agente'" class="btn">
          Agenti
          immobiliari
        </div>
        <div (click)="this.searchByPlace('agenzia', true)"
          [class.btn--selected]="this.main.isAgentSearch && this.main?.searchType == 'agenzia'" class="btn mx-2">
          Agenzie immobiliari
        </div>
        <div (click)="this.searchByPlace('professionista', false)" [class.btn--selected]="!this.main.isAgentSearch"
          class="btn">Consulenti del credito e
          assicurativo
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="searchForm" [class.searchFormWhite]="this.isHome && this.is404"
    [class.noRadius]="this.main?.searchDropdown || this.main?.searchDropdownCityZones">
    <!-- SELEZIONA RICERCA PER NOME O PER LUOGO -->
    <div class="searchForm__select-box-method-type dropdown"
      *ngIf="this.main?.searchType == 'agenzia' || this.main?.searchType == 'agente' || (this.main?.searchType == 'professionista' && this.main.searchMethodType === 'place')">
      <p id="globalSearchBarTypeContainer" class="button-width"
        [class.button-width-open]="this.main.searchMethodTypeDropdown">
        Cerca per: <b>{{ this.main.searchMethodType == 'place' ? 'Luogo' : 'Nome' }}</b>
        <i *ngIf="!this.main.searchMethodTypeDropdown" class="arrow icon-chevron-down"></i>
        <i *ngIf="this.main.searchMethodTypeDropdown" class="arrow icon-chevron-up"></i>
      </p>
      <div class="dropdown-range dropdown-range-search-bar"
        [style.display]="this.main.searchMethodTypeDropdown ? 'block' : 'none'">
        <ul class="list-unstyled p-0 m-0">
          <li class="p-0 m-0" (click)="this.clickMethodType('name');">
            <p class="m-0 list-type">
              <i class="pe-1" [class.text-primary]="this.main.searchMethodType == 'name'"
                [class.icon-dot-circle-solid]="this.main.searchMethodType == 'name'"
                [class.icon-circle-solid]="this.main.searchMethodType == 'name'"
                [class.icon-circle-regular]="this.main.searchMethodType == 'place'"></i>
              Nome
            </p>
          </li>
          <li class="p-0 m-0" (click)="this.clickMethodType('place');">
            <p class="m-0 list-type">
              <i class="pe-1" [class.text-primary]="this.main.searchMethodType == 'place'"
                [class.icon-dot-circle-solid]="this.main.searchMethodType == 'place'"
                [class.icon-circle-solid]="this.main.searchMethodType == 'place'"
                [class.icon-circle-regular]="this.main.searchMethodType == 'name'"></i>
              Luogo
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- BARRA DI RICERCA -->
    <div id="globalSearchBarContainer" class="searchForm__searchField"
      [class.searchField-50]="(this.main?.searchType == 'agenzia' || this.main?.searchType == 'agente' || this.main?.searchType == 'professionista') && this.main.searchMethodType == 'place'"
      [class.searchField-75]="this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto' || this.main.searchMethodType == 'name' || this.isWhiteLabel">
      <i class="icon-search icon-search-bar"></i>
      <input autocomplete="off" id="globalSearchBarInput" (focus)="this.resetAndOpenInput()" [value]="this.searchValue"
        (keyup)="this.onKeyUpInput($event, $event.target.value)" type="text" class="input"
        placeholder="{{this.placeholder}}" [class.notHome]="!this.isHome && !this.is404" #globalSearchBarInput>
      <i class="icon-times clearField" *ngIf="!this.isHome && !this.is404 && globalSearchBarInput.value!==''"
        (click)="this.resetAndOpenInput(true); $event.stopPropagation()"></i>
      <i class="fas clearField" [class.icon-chevron-down]="!this.main?.searchDropdownCityZones"
        [class.icon-chevron-up]="this.main?.searchDropdownCityZones" *ngIf="this.selectedCity"
        (click)="this.main.searchDropdownCityZones = !this.main.searchDropdownCityZones; $event.stopPropagation()"></i>
    </div>

    <!-- SELEZIONA CATEGORIA O COMPANY -->
    <div id="globalDropdownContainer"
      *ngIf="!this.isWhiteLabel && ((this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto' || this.main?.searchType == 'agenzia') && !this.isMobile || this.isMobile)"
      class="searchForm__select-box-category dropdown">
      <p class="button-width" [class.button-width-open]="this.main.searchCategoryDropdown"
        (click)="this.toggleMobileDropdown()">
        {{ this.showLabelType() }}
        <i *ngIf="!this.main.searchCategoryDropdown" class="arrow icon-chevron-down"></i>
        <i *ngIf="this.main.searchCategoryDropdown" class="arrow icon-chevron-up"></i>
      </p>
      <div class="dropdown-range dropdown-range-search-bar"
        [style.display]="this.main.searchCategoryDropdown ? 'block' : 'none'" *ngIf="!this.isMobile">
        <ul class="list-unstyled p-0 m-0 pt-2 pb-2">
          <li class="p-0 m-0" (click)="this.selectAll()"
            *ngIf="this.main?.searchType!=='agente' && this.main?.searchType!=='agenzia'">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="this.searchCategoria == null"
                [class.icon-dot-circle-solid]="this.searchCategoria == null"
                [class.icon-circle-solid]="this.searchCategoria == null"
                [class.icon-circle-regular]="this.searchCategoria != null"></i>
              {{ (this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto') ? 'Tutte le tipologie' :
              'Tutte le agenzie' }}
            </p>
          </li>

          <!-- LISTA DI TIPOLOGIE -->
          <ng-container *ngIf="this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto'">
            <ng-container *ngFor="let macroType of this.listOfTypologies">
              <li class="p-0 m-0">

                <!-- MACRO CATEGORIA -->
                <p class="m-0 list-type" (click)="this.clickParentType(macroType, true)">
                  <i class="pe-2" [class.text-primary]="this.selectedParentType(macroType)"
                    [class.icon-dot-circle-solid]="this.selectedParentType(macroType)"
                    [class.icon-circle-solid]="this.selectedParentType(macroType)"
                    [class.icon-circle-regular]="!this.selectedParentType(macroType)"></i>
                  {{ macroType.text }}
                  <ng-container *ngIf="macroType.value.length > 1">
                    <i *ngIf="this.openCategory != macroType.id" class="icon-chevron-down"></i>
                    <i *ngIf="this.openCategory == macroType.id" class="icon-chevron-up"></i>
                  </ng-container>
                </p>

                <!-- SOTTO CATEGORIE -->
                <ul [hidden]="!(macroType.value.length > 1 && this.openCategory == macroType.id)">
                  <li class="p-0 m-0" (click)="this.clickParentType(macroType, false)">
                    <p class="m-0 list-type-child">
                      <i class="pe-2" [class.text-primary]="this.childType.length == 0"
                        [class.icon-check-square]="this.childType.length == 0"
                        [class.icon-square-regular]="this.childType.length !== 0"></i>
                      Tutte le tipologie: {{ macroType.text }}
                    </p>
                  </li>
                  <li class="p-0 m-0" *ngFor="let subType of macroType.value">
                    <p class="m-0 list-type-child" (click)="this.clickChildType(subType, macroType)">
                      <i class="pe-2" [class.text-primary]="this.selectedChildType(subType,macroType)"
                        [class.icon-check-square]="this.selectedChildType(subType,macroType)"
                        [class.icon-square-regular]="this.selectedChildType(subType,macroType)"
                        [class.icon-square-regular]="!this.selectedChildType(subType,macroType)"></i>
                      {{ subType.text }}
                    </p>
                  </li>
                </ul>

              </li>
            </ng-container>
          </ng-container>

          <!--- OLD AGENT / PROFESSIONIST DROPDOWN -->
          <ng-container *ngIf="this.main?.searchType == 'agente'">
            <li class="p-0 m-0" (click)="this.searchByName(true); $event.stopPropagation()"
              [hidden]="!this.showAgencies">
              <p class="m-0 list-type">
                <i class="pe-2" [class.text-primary]="this.main.isAgentSearch"
                  [class.icon-dot-circle-solid]="this.main.isAgentSearch"
                  [class.icon-circle-solid]="this.main.isAgentSearch"
                  [class.icon-circle-regular]="!this.main.isAgentSearch"></i>
                Agenti immobiliari {{ this.isMobile }}
              </p>
            </li>
            <ng-container *ngIf="this.showProfessionist">
              <li class="p-0 m-0" (click)="this.searchByName(false); $event.stopPropagation()"
                [hidden]="!this.showAgencies">
                <p class="m-0 list-type">
                  <i class="pe-2" [class.text-primary]="!this.main.isAgentSearch"
                    [class.icon-dot-circle-solid]="!this.main.isAgentSearch"
                    [class.icon-circle-solid]="!this.main.isAgentSearch"
                    [class.icon-circle-regular]="this.main.isAgentSearch"></i>
                  Consulenti del credito e assicurativo
                </p>
              </li>
            </ng-container>
          </ng-container>

          <!-- LISTA DI COMPANY -->
          <ng-container *ngIf="this.main?.searchType == 'agenzia'">
            <p class="m-0 list-type" (click)="this.showAgencies=!this.showAgencies; $event.stopPropagation()">
              Agenzie
              <ng-container>
                <i *ngIf="!this.showAgencies" class="icon-chevron-down"></i>
                <i *ngIf="this.showAgencies" class="icon-chevron-up"></i>
              </ng-container>
            </p>
            <li class="p-0 m-0" (click)="this.removeParentType(); $event.stopPropagation()"
              [hidden]="!this.showAgencies">
              <p class="m-0 list-type">
                <i class="pe-2" [class.text-primary]="!this.parentType" [class.icon-dot-circle-solid]="!this.parentType"
                  [class.icon-circle-solid]="!this.parentType" [class.icon-circle-regular]="this.parentType"></i>
                Tutte le agenzie
              </p>
            </li>
            <ng-container *ngFor="let macroCompany of this.listOfCompany">
              <li class="p-0 m-0" (click)="this.clickParentType(macroCompany, null); $event.stopPropagation()"
                [hidden]="!this.showAgencies">
                <p class="m-0 list-type">
                  <i class="pe-2" [class.text-primary]="this.selectedParentType(macroCompany)"
                    [class.icon-dot-circle-solid]="this.selectedParentType(macroCompany)"
                    [class.icon-circle-solid]="this.selectedParentType(macroCompany)"
                    [class.icon-circle-regular]="!this.selectedParentType(macroCompany)"></i>
                  {{ macroCompany.text }}
                </p>
              </li>
            </ng-container>
            <p class="m-0 list-type" (click)="this.showAssociations=!this.showAssociations; $event.stopPropagation()">
              Associazioni
              <ng-container>
                <i *ngIf="!this.showAssociations" class="icon-chevron-down"></i>
                <i *ngIf="this.showAssociations" class="icon-chevron-up"></i>
              </ng-container>
            </p>
            <li class="p-0 m-0" (click)="this.removeAssociations(); $event.stopPropagation()"
              [hidden]="!this.showAssociations">
              <p class="m-0 list-type">
                <i class="pe-2"
                  [class.text-primary]="!this.main?.filtersList.associations || this.main?.filtersList.associations.length<1"
                  [class.icon-check-square]="!this.main?.filtersList.associations || this.main?.filtersList.associations.length<1"
                  [class.icon-square-regular]="!this.main?.filtersList.associations || this.main?.filtersList.associations.length<1"
                  [class.icon-square-regular]="this.main?.filtersList.associations && this.main?.filtersList.associations.length>0"></i>
                Tutte le associazioni
              </p>
            </li>
            <ng-container *ngFor="let association of this.associations">
              <li class="p-0 m-0" (click)="changeAssociationsStatus(association.text, $event); $event.stopPropagation()"
                [hidden]="!this.showAssociations">
                <p class="m-0 list-type">
                  <i class="pe-2"
                    [class.text-primary]="this.checkChekbox(association.text, this.main?.filtersList.associations)"
                    [class.icon-check-square]="this.checkChekbox(association.text, this.main?.filtersList.associations)"
                    [class.icon-square-regular]="!this.checkChekbox(association.text, this.main?.filtersList.associations)"></i>
                  {{ association.id | uppercase }}
                </p>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="fullscreen-dropdown" *ngIf="this.isMobile && this.openFixedList">
      <div class="fullscreen-dropdown-header">
        <p>Seleziona un'opzione</p>
        <i class="icon-times" (click)="this.toggleMobileDropdown()"></i>
      </div>
      <ul class="list-unstyled p-0 m-0">
        <li class="p-2 pr-0 m-0" (click)="this.selectAll()"
          *ngIf="this.main?.searchType==='vendita' || this.main?.searchType==='affitto'">
          <p class="m-0 list-type">
            <i class="pe-2" [class.text-primary]="this.searchCategoria == null"
              [class.icon-dot-circle-solid]="this.searchCategoria == null"
              [class.icon-circle-solid]="this.searchCategoria == null"
              [class.icon-circle-regular]="this.searchCategoria != null"></i>
            Tutte le tipologie
          </p>
        </li>

        <!-- LISTA DI TIPOLOGIE -->
        <ng-container *ngIf="this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto'">
          <ng-container *ngFor="let macroType of this.listOfTypologies">
            <li class="p-2 pr-0 m-0">

              <!-- MACRO CATEGORIA -->
              <p class="m-0 list-type" (click)="this.clickParentType(macroType, true)">
                <i class="pe-2" [class.text-primary]="this.selectedParentType(macroType)"
                  [class.icon-dot-circle-solid]="this.selectedParentType(macroType)"
                  [class.icon-circle-solid]="this.selectedParentType(macroType)"
                  [class.icon-circle-regular]="!this.selectedParentType(macroType)"></i>
                {{ macroType.text }}
                <ng-container *ngIf="macroType.value.length > 1">
                  <i *ngIf="this.openCategory != macroType.id" class="icon-chevron-down ms-2"></i>
                  <i *ngIf="this.openCategory == macroType.id" class="icon-chevron-up ms-2"></i>
                </ng-container>
              </p>

              <!-- SOTTO CATEGORIE -->
              <ul [hidden]="!(macroType.value.length > 1 && this.openCategory == macroType.id)">
                <li class="p-2 pr-0 m-0" (click)="this.clickParentType(macroType, false)">
                  <p class="m-0 list-type-child">
                    <i class="pe-2" [class.text-primary]="this.childType.length == 0"
                      [class.icon-check-square-regular]="this.childType.length == 0"
                      [class.icon-square-regular]="this.childType.length !== 0"></i>
                    Tutte le tipologie: {{ macroType.text }}
                  </p>
                </li>
                <li class="p-2 pr-0 m-0" *ngFor="let subType of macroType.value">
                  <p class="m-0 list-type-child" (click)="this.clickChildType(subType, macroType)">
                    <i class="pe-2" [class.text-primary]="this.selectedChildType(subType,macroType)"
                      [class.icon-check-square]="this.selectedChildType(subType,macroType)"
                      [class.icon-square-regular]="!this.selectedChildType(subType,macroType)"></i>
                    {{ subType.text }}
                  </p>
                </li>
              </ul>
            </li>
          </ng-container>
        </ng-container>

        <!-- LISTA DI COMPANY -->
        <ng-container
          *ngIf="(this.main?.searchType == 'agente' || this.main?.searchType == 'agenzia' || this.main?.searchType == 'professionista') && this.main.searchMethodType == 'name'">
          <li class="p-2 m-0" (click)="this.searchByName(true); $event.stopPropagation()" [hidden]="!this.showAgencies">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="this.main.isAgentSearch"
                [class.icon-dot-circle-solid]="this.main.isAgentSearch"
                [class.icon-circle-solid]="this.main.isAgentSearch"
                [class.icon-circle-regular]="!this.main.isAgentSearch"></i>
              Agenti e agenzie immobiliari
            </p>
          </li>
          <li class="p-2 m-0" (click)="this.searchByName(false); $event.stopPropagation()"
            [hidden]="!this.showAgencies">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="!this.main.isAgentSearch"
                [class.icon-dot-circle-solid]="!this.main.isAgentSearch"
                [class.icon-circle-solid]="!this.main.isAgentSearch"
                [class.icon-circle-regular]="this.main.isAgentSearch"></i>
              Consulenti del credito e assicurativo
            </p>
          </li>
        </ng-container>

        <ng-container
          *ngIf="(this.main?.searchType == 'agente' || this.main?.searchType == 'agenzia' || this.main?.searchType == 'professionista') && this.main.searchMethodType == 'place'">
          <li class="p-2 m-0" (click)="this.searchByPlace('agente', true); $event.stopPropagation()"
            [hidden]="!this.showAgencies">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="this.main?.searchType == 'agente'"
                [class.icon-dot-circle-solid]="this.main?.searchType == 'agente'"
                [class.icon-circle-solid]="this.main?.searchType == 'agente'"
                [class.icon-circle-regular]="this.main?.searchType != 'agente'"></i>
              Agenti immobiliari
            </p>
          </li>
          <li class="p-2 m-0" (click)="this.searchByPlace('agenzia', true); $event.stopPropagation()"
            [hidden]="!this.showAgencies">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="this.main?.searchType == 'agenzia'"
                [class.icon-dot-circle-solid]="this.main?.searchType == 'agenzia'"
                [class.icon-circle-solid]="this.main?.searchType == 'agenzia'"
                [class.icon-circle-regular]="this.main?.searchType != 'agenzia'"></i>
              Agenzie immobiliari
            </p>
          </li>
          <li class="p-2 m-0" (click)="this.searchByPlace('professionista', false); $event.stopPropagation()"
            [hidden]="!this.showAgencies">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="this.main?.searchType == 'professionista'"
                [class.icon-dot-circle-solid]="this.main?.searchType == 'professionista'"
                [class.icon-circle-solid]="this.main?.searchType == 'professionista'"
                [class.icon-circle-regular]="this.main?.searchType != 'professionista'"></i>
              Consulenti del credito e assicurativo
            </p>
          </li>
        </ng-container>

        <ng-container *ngIf="this.main?.searchType == 'agenzia'">
          <p class="m-0 py-2 list-type" (click)="this.showAgencies=!this.showAgencies; $event.stopPropagation()">
            Agenzie
            <ng-container>
              <i *ngIf="!this.showAgencies" class="icon-chevron-down ms-2"></i>
              <i *ngIf="this.showAgencies" class="icon-chevron-up ms-2"></i>
            </ng-container>
          </p>
          <li class="p-2 m-0" (click)="this.removeParentType(); $event.stopPropagation()" [hidden]="!this.showAgencies">
            <p class="m-0 list-type">
              <i class="pe-2" [class.text-primary]="!this.parentType" [class.icon-dot-circle-solid]="!this.parentType"
                [class.icon-circle-solid]="!this.parentType" [class.icon-circle-regular]="this.parentType"></i>
              Tutte le agenzie
            </p>
          </li>
          <ng-container *ngFor="let macroCompany of this.listOfCompany">
            <li class="p-2 m-0" (click)="this.clickParentType(macroCompany, null); $event.stopPropagation()"
              [hidden]="!this.showAgencies">
              <p class="m-0 list-type">
                <i class="pe-2" [class.text-primary]="this.selectedParentType(macroCompany)"
                  [class.icon-dot-circle-solid]="this.selectedParentType(macroCompany)"
                  [class.icon-circle-solid]="this.selectedParentType(macroCompany)"
                  [class.icon-circle-regular]="!this.selectedParentType(macroCompany)"></i>
                {{ macroCompany.text }}
              </p>
            </li>
          </ng-container>
          <p class="m-0 py-2 list-type"
            (click)="this.showAssociations=!this.showAssociations; $event.stopPropagation()">
            Associazioni
            <ng-container>
              <i *ngIf="!this.showAssociations" class="icon-chevron-down ms-2"></i>
              <i *ngIf="this.showAssociations" class="icon-chevron-up ms-2"></i>
            </ng-container>
          </p>
          <li class="p-2 m-0" (click)="this.removeAssociations(); $event.stopPropagation()"
            [hidden]="!this.showAssociations">
            <p class="m-0 list-type">
              <i class="pe-2"
                [class.text-primary]="!this.main?.filtersList.associations || this.main?.filtersList.associations.length<1"
                [class.icon-check-square-regular]="!this.main?.filtersList.associations || this.main?.filtersList.associations.length<1"
                [class.icon-square-regular]="this.main?.filtersList.associations && this.main?.filtersList.associations.length>0"></i>
              Tutte le associazioni
            </p>
          </li>
          <ng-container *ngFor="let association of this.associations">
            <li class="p-2 m-0" (click)="changeAssociationsStatus(association.text, $event); $event.stopPropagation()"
              [hidden]="!this.showAssociations">
              <p class="m-0 list-type">
                <i class="pe-2"
                  [class.text-primary]="this.checkChekbox(association.text, this.main?.filtersList.associations)"
                  [class.icon-check-square]="this.checkChekbox(association.text, this.main?.filtersList.associations)"
                  [class.icon-square-regular]="!this.checkChekbox(association.text, this.main?.filtersList.associations)"></i>
                {{ association.id | uppercase }}
              </p>
            </li>
          </ng-container>
        </ng-container>

      </ul>
      <div class="fullscreen-dropdown-footer">
        <button class="btn btn-primary w-100" (click)="this.toggleMobileDropdown()">Conferma</button>
      </div>
    </div>

    <!-- TENDINA CON SUGGERIMENTI DI RICERCA -->
    <div class="searchForm__dropDown" *ngIf="this.main.searchMethodType == 'place'">
      <div class="default_option"></div>
      <div class="ulContainer" id="searchFormDropdown"
        [class.extendTop]="this.main?.searchType == 'agenzia' || this.main?.searchType == 'agente'"
        [class.ulContainer--open]="this.main?.searchDropdown">
        <ul *ngIf="!this.toggleSearch" class="left">
          <li (click)="this.metodo = 1" [class.active]="this.metodo == 1">
            <div class="option">
              <p class="m-0 p-0">
                <i class="icon-search"></i>
                Digita indirizzo, città o provincia
              </p>
            </div>
          </li>
          <li (click)="this.selezionaTipologiaRicerca(2)" [class.active]="this.metodo == 2">
            <div class="option">
              <p class="m-0 p-0">
                <i class="icon-street-view"></i>
                Vicino a dove ti trovi
              </p>
            </div>
          </li>
          <li (click)="this.selezionaTipologiaRicerca(3)" [class.active]="this.metodo == 3">
            <div class="option">
              <p class="m-0 p-0">
                <i class="icon-map-pin"></i>
                Seleziona zona su mappa
              </p>
            </div>
          </li>
          <li (click)="this.selezionaTipologiaRicerca(4)" [class.active]="this.metodo == 4">
            <div class="option">
              <p class="m-0 p-0">
                <i class="icon-draw-polygon"></i>
                Disegna area su mappa
              </p>
            </div>
          </li>
        </ul>

        <ul *ngIf="this.toggleSearch" class="left" [class.left--whiteLabel]="this.isWhiteLabel">
          <li class="option-loading" *ngIf="this.suggestionResult == null; else showResultsSearch">
            <p class="m-0 p-0">
              <app-loading [width]="20" [height]="20"></app-loading>
              <span class="ms-2">Caricamento..</span>
            </p>
          </li>
          <ng-template #showResultsSearch>
            <li *ngIf="this.suggestionResult?.length === 0" class="option-not-found">
              <div class="option">
                <p class="m-0 p-0">
                  <i class="icon-exclamation-triangle text-primary"></i>
                  Nessun risultato trovato
                </p>
              </div>
            </li>
            <ng-container *ngFor="let result of this.suggestionResult; let i = index">
              <li (click)="this.selectOption(result)" [class.me-0]="this.isWhiteLabel">
                <div class="option" [class.focus]="this.suggestionFocus === i">
                  <p class="m-0 p-0">
                    <i class="icon-map-marker-alt me-1"></i>
                    <ng-container *ngIf="result.type === 'Google'">
                      <b>{{ result.name }}</b> • {{ result.type }}
                    </ng-container>
                    <ng-container *ngIf="result.type === 'Zona'">
                      <b>{{ result.display_name }} ({{ result.properties.comune_name }})</b> •
                      {{ result.type }}
                    </ng-container>
                    <ng-container *ngIf="result.type !== 'Zona' && result.type !== 'Zona'">
                      <b>{{ result.display_name }}</b> • {{ result.type }}
                    </ng-container>
                  </p>
                </div>
              </li>
            </ng-container>
          </ng-template>
        </ul>

        <div class="right" *ngIf="this.main?.objRicercheRecenti.length > 0 && !this.isWhiteLabel">
          <h5 class="m-0 p-0">Ricerche recenti</h5>
          <ng-container *ngFor="let value of this.main?.objRicercheRecenti | slice:0:4">
            <p class="m-0 cursor-pointer" (click)="nav(value?.url)">
              <i class="me-2" [class]="this.typeSearchIcon(value)"></i>
              <span class="badge badge-success me-1" *ngIf="value && this.returnFiltersNumber(value)">Filtri</span>
              <span class="fw-600">{{ value?.type | titlecase }} •</span> {{ value?.placeholder | titlecase }}
            </p>
          </ng-container>
          <a *ngIf="this.isLogged && this.main?.objRicercheRecenti?.length > 5" href="javascript:void(0);"
            [routerLink]="['/utente-ricerche']" class="p-0 m-0 ps-2 text-underline text-primary cursor-pointer">Vedi
            tutte le ricerche
            recenti</a>
        </div>
      </div>
    </div>

    <!-- TENDINA CON SUGGERIMENTI DI ZONE COMUNE -->
    <div class="searchForm__dropDown cityZones" *ngIf="this.main.searchMethodType == 'place'">
      <div class="ulContainer" id="cityZonesSelector"
        [class.extendTop]="this.main?.searchType == 'agenzia' || this.main?.searchType == 'agente'"
        [class.ulContainer--open]="this.main?.searchDropdownCityZones">
        <div class="fullscreen-dropdown-cityZones-header">
          <p>Seleziona una o più zone</p><i class="icon-times" (click)="this.closeZoneSelector()"></i>
        </div>
        <ul *ngIf="!this.toggleSearch" class="left">
          <p class="px-2 d-flex align-items-center justify-content-between">
            <span>Zone</span>
            <span (click)="this.selezionaTipologiaRicerca(3)" class="me-2 cursor-pointer text-primary">Vedi
              zone
              su mappa</span>
          </p>
          <li>
            <div class="option">
              <label class="m-0 p-0 w-100 d-flex align-items-center justify-content-start cursor-pointer"
                for="tutte-le-zone">
                <input type="checkbox" name="tutte-le-zone" id="tutte-le-zone" class="me-2"
                  (change)="this.selectAllCityZones($event)" [checked]="this.cityZonesSelected.length===0">
                Tutte le zone
              </label>
            </div>
          </li>
          <li *ngFor="let zone of this.returnSortedArray()">
            <div class="option">
              <label class="m-0 p-0 w-100 d-flex align-items-center justify-content-start cursor-pointer"
                [for]="zone.name">
                <input type="checkbox" [name]="zone.name" [id]="zone.name" class="me-2"
                  (change)="this.clickOnCityZone(zone.name)" [checked]="this.checkSelectedZones(zone.name)">
                {{ zone.display_name }}
              </label>
            </div>
          </li>
        </ul>

        <div class="right" *ngIf="this.main?.objRicercheRecenti.length > 0">
          <h5 class="m-0 p-0">Ricerche recenti</h5>
          <ng-container *ngFor="let value of this.main?.objRicercheRecenti | slice:0:4">
            <p class="m-0 cursor-pointer" (click)="nav(value?.url)">
              <i class="fas" [class]="this.typeSearchIcon(value)"></i>
              <span class="badge badge-success me-2" *ngIf="value && this.returnFiltersNumber(value)">Filtri</span>
              <span class="fw-600">{{ value?.type | titlecase }} •</span> {{ value?.placeholder | titlecase }}
            </p>
          </ng-container>
          <a *ngIf="this.isLogged && this.main?.objRicercheRecenti?.length > 5" href="javascript:void(0);"
            [routerLink]="['/utente-ricerche']" class="p-0 m-0 ps-2 text-underline text-primary cursor-pointer">Vedi
            tutte le ricerche
            recenti</a>
        </div>
        <div class="fullscreen-dropdown-cityZones-footer" (click)="this.closeZoneSelector()">
          <button class="btn btn-primary w-100">Conferma
          </button>
        </div>
      </div>
    </div>

    <!-- TENDINA CON SUGGERIMENTI DI RICERCA PER NOME - AGENTE O AGENZIA -->
    <div class="searchForm__dropDown"
      *ngIf="this.main.searchMethodType == 'name' && (this.main?.searchType == 'agenzia' || this.main?.searchType == 'agente')">
      <div class="default_option"></div>
      <div class="ulContainer ulContainer-name extendTop"
        [class.ulContainer--open]="this.main?.searchNameDropdown && this.toggleSearch">
        <ul class="left">
          <li class="option-loading" [class.me-0]="this.isWhiteLabel"
            *ngIf="this.suggestionResult == null; else showResultsSearch">
            <p class="m-0 p-0">
              <app-loading [width]="20" [height]="20"></app-loading>
              <span class="ms-2">Caricamento..</span>
            </p>
          </li>
          <ng-template #showResultsSearch>
            <li *ngIf="this.suggestionResult?.length === 0" class="option-not-found">
              <div class="option">
                <p class="m-0 p-0">
                  <i class="icon-exclamation-triangle text-primary"></i>
                  Nessun risultato trovato
                </p>
              </div>
            </li>
            <ng-container *ngIf="this.main?.searchType == 'agente'">
              <ng-container *ngFor="let result of this.suggestionResult; let i = index">
                <ng-container *ngIf="!this.isWhiteLabel">
                  <app-suggested-result (openAtecoPopupEvt)="openAtecoPopup(result, result.name)" [result]="result"
                    [hasFocus]="this.suggestionFocus === i"></app-suggested-result>
                </ng-container>

                <!-- WHITE LABEL RESULT -->
                <ng-container *ngIf="result.agent && this.isWhiteLabel">
                  <li routerLink="/dettaglio-agente/{{result.agent?.slug}}">
                    <div class="option" [class.focus]="this.suggestionFocus === i">
                      <div class="d-flex">
                        <ng-container
                          *ngIf="result?.agent?.member?.profile_img && result?.agent?.member?.profile_img !== ''; else iconImage">
                          <div class="agentimg position-relative">
                            <img [ngSrc]="result?.agent?.member?.profile_img" fill="center"
                              alt="immagine agente cercacasa">
                          </div>
                        </ng-container>
                        <ng-template #iconImage>
                          <div class="agentimg agentimg--brokenLogo d-flex align-items-center justify-content-center">
                            <i class="icon-user-tie me-0"></i>
                          </div>
                        </ng-template>
                        <div class="w-100 d-flex align-items-between flex-column">
                          <p class="m-0 p-0">
                            <b>{{ result.full_name }}</b> • {{ result.agent?.agency?.name }}

                            {{
                            this.main.getAssociationName(
                            result?.agent?.association)
                            }}
                          </p>
                          <div class="d-flex align-items-center justify-content-between">
                            <p class="mb-0">Agente</p>
                            <img class="logo-cercacasa-small ms-2" width="110" height="18"
                              [ngSrc]="'assets/img/logoblu.png'" alt="logo cercacsa">
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ng-container>

              </ng-container>
            </ng-container>

          </ng-template>
        </ul>
      </div>
    </div>

    <button (click)="this.applySearch()" [disabled]="this.searchDisabled()" type="submit"
      class="btn btn-primary btn-primary__search" name="button">Cerca
    </button>
  </div>
</div>


<app-search-bar-map *ngIf="this.showMap" [openMapEvents]="this.openMapSubject.asObservable()" [hidden]="!this.showMap"
  (closeEvent)="this.getEventAndCloseMap($event)" (changeEvent)="this.changeMethod($event)"
  [citySelected]="this.selectedCity"></app-search-bar-map>

<ng-container
  *ngIf="(this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto') && !this.isHome && !this.is404">
  <div class="row align-items-center">
    <!-- FILTRO PREZZO VENDITA -->
    <div *ngIf="this.main?.searchType == 'vendita'" class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.bgRed]="this.showFilters" [class.d-block]="this.showFilters"
      [class.active]="this.main?.filtersList.minPrice || this.main?.filtersList.maxPrice">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('price', minPrice)"
          [innerHTML]="this.showPriceLabel()"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'price' ? 'block' : 'none'">
          <div class="dropdown-range-input">
            <input #minPrice id="minPrice" type="number" class="form-control price-label" placeholder="Da"
              (focus)="this.onFocusInput(1)" (change)="this.changeValue($event.target.value, 'minPrice')" />
            <input #maxPrice id="maxPrice" type="number" class="form-control price-label" placeholder="A"
              (focus)="this.onFocusInput(2)" (change)="this.changeValue($event.target.value, 'maxPrice')" />
          </div>
          <ul class="text-start list-unstyled" [style.display]="this.listRange == 1 ? 'block' : 'none'">
            <li (click)="this.setFilter('minPrice', null, 2, maxPrice)">Nessun limite</li>
            <ng-container *ngFor="let minP of this.optionsPrice">
              <li (click)="this.setFilter('minPrice', minP*1000, 2, maxPrice)">{{
                minP * 1000 |
                currencyITFormat:'EUR':'€':"1.0-2"
                }}
              </li>
            </ng-container>
          </ul>
          <ul class="text-end list-unstyled" [style.display]="this.listRange == 2 ? 'block' : 'none'">
            <li (click)="this.setFilter('maxPrice', null, null, null)">Nessun limite</li>
            <ng-container *ngFor="let maxP of this.optionsPrice">
              <li *ngIf="!this.main?.filtersList?.minPrice || (maxP*1000) >= this.main?.filtersList?.minPrice"
                (click)="this.setFilter('maxPrice', maxP*1000, null, null)">{{
                maxP * 1000 |
                currencyITFormat:'EUR':'€':"1.0-2"
                }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO PREZZO AFFITTO -->
    <div *ngIf="this.main?.searchType == 'affitto'" [class.d-block]="this.showFilters"
      class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList.minPrice || this.main?.filtersList.maxPrice">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('price', minPrice)"
          [innerHTML]="this.showPriceLabel()"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'price' ? 'block' : 'none'">
          <div class="dropdown-range-input">
            <input #minPrice id="minPrice" type="number" class="form-control price-label" placeholder="Da"
              (focus)="this.onFocusInput(1)" (change)="this.changeValue($event.target.value, 'minPrice')" />
            <input #maxPrice id="maxPrice" type="number" class="form-control price-label" placeholder="A"
              (focus)="this.onFocusInput(2)" (change)="this.changeValue($event.target.value, 'maxPrice')" />
          </div>
          <ul class="text-start list-unstyled" [style.display]="this.listRange == 1 ? 'block' : 'none'">
            <li (click)="this.setFilter('minPrice', null, 2, maxPrice)">Nessun limite</li>
            <ng-container *ngFor="let minP of this.optionsPrice">
              <li (click)="this.setFilter('minPrice', minP*10, 2, maxPrice)">{{
                minP * 10 |
                currencyITFormat
                }}
              </li>
            </ng-container>
          </ul>
          <ul class="text-end list-unstyled" [style.display]="this.listRange == 2 ? 'block' : 'none'">
            <li (click)="this.setFilter('maxPrice', null, null, null)">Nessun limite</li>
            <ng-container *ngFor="let maxP of this.optionsPrice">
              <li *ngIf="!this.main?.filtersList?.minPrice || (maxP*10) >= this.main?.filtersList?.minPrice"
                (click)="this.setFilter('maxPrice', maxP*10, null, null)">{{
                maxP * 10 |
                currencyITFormat
                }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO SUPERFICIE -->
    <div [class.d-block]="this.showFilters" class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList.minMQ || this.main?.filtersList.maxMQ">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('mq', minMQ)"
          [innerHTML]="this.showMQLabel(this.main?.filtersList?.minMQ, this.main?.filtersList?.maxMQ)"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'mq' ? 'block' : 'none'">
          <div class="dropdown-range-input">
            <input #minMQ id="minMQ" type="number" class="form-control price-label" placeholder="Da"
              (focus)="this.onFocusInput(1)" (change)="this.changeValue($event.target.value, 'minMQ')" />
            <input #maxMQ id="maxMQ" type="number" class="form-control price-label" placeholder="A"
              (focus)="this.onFocusInput(2)" (change)="this.changeValue($event.target.value, 'maxMQ')" />
          </div>
          <ul class="text-start list-unstyled" [style.display]="this.listRange == 1 ? 'block' : 'none'">
            <li (click)="this.setFilter('minMQ', minP, null, maxMQ)">Nessun limite</li>
            <ng-container *ngFor="let minP of this.optionsMQ">
              <li (click)="this.setFilter('minMQ', minP, 2, maxMQ)">{{ minP }} mq</li>
            </ng-container>
          </ul>
          <ul class="text-end list-unstyled" [style.display]="this.listRange == 2 ? 'block' : 'none'">
            <li (click)="this.setFilter('maxMQ', null, null, null)">Nessun limite</li>
            <ng-container *ngFor="let maxP of this.optionsMQ">
              <li *ngIf="!this.main?.filtersList?.minMQ || maxP >= this.main?.filtersList?.minMQ"
                (click)="this.setFilter('maxMQ', maxP, null, null)">{{ maxP }} mq
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO NUMERO LOCALI -->
    <div [class.d-block]="this.showFilters" class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList.minLocali || this.main?.filtersList.maxLocali">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('locali', minLocali)"
          [innerHTML]="this.showLocaliLabel(this.main?.filtersList?.minLocali, this.main?.filtersList?.maxLocali)"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'locali' ? 'block' : 'none'">
          <div class="dropdown-range-input">
            <input #minLocali id="minLocali" type="number" class="form-control price-label" placeholder="Da"
              (focus)="this.onFocusInput(1)" (change)="this.changeValue($event.target.value, 'minLocali')" />
            <input #maxLocali id="maxLocali" type="number" class="form-control price-label" placeholder="A"
              (focus)="this.onFocusInput(2)" (change)="this.changeValue($event.target.value, 'maxLocali')" />
          </div>
          <ul class="text-start list-unstyled" [style.display]="this.listRange == 1 ? 'block' : 'none'">
            <li (click)="this.setFilter('minLocali', null, 2, maxLocali)">Nessun limite</li>
            <ng-container *ngFor="let minP of this.optionsLocali">
              <li (click)="this.setFilter('minLocali', minP, 2, maxLocali)">{{ minP }}</li>
            </ng-container>
          </ul>
          <ul class="text-end list-unstyled" [style.display]="this.listRange == 2 ? 'block' : 'none'">
            <li (click)="this.setFilter('maxLocali', null, null, null)">Nessun Limite</li>
            <ng-container *ngFor="let maxP of this.optionsLocali">
              <li *ngIf="!this.main?.filtersList?.minLocali || maxP >= this.main?.filtersList?.minLocali"
                (click)="this.setFilter('maxLocali', maxP, null, null)">{{ maxP }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO RATA MUTUO -->
    <div *ngIf="this.main?.searchType == 'vendita'" [class.d-block]="this.showFilters"
      class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList.minFinanziamento || this.main?.filtersList.maxFinanziamento">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('finanziamento', minFinanziamento)"
          [innerHTML]="this.showFinanziamentoLabel(this.main?.filtersList?.minFinanziamento, this.main?.filtersList?.maxFinanziamento)"></button>
        <div class="dropdown-range dropdown-finanziamento"
          [style.display]="this.idDropdownOpen == 'finanziamento' ? 'block' : 'none'">
          <p class="m-0">Durata 30 anni</p>
          <div class="dropdown-range-input">
            <input #minFinanziamento id="minFinanziamento" type="number" class="form-control price-label"
              placeholder="Da" (focus)="this.onFocusInput(1)"
              (change)="this.changeValue($event.target.value, 'minFinanziamento')" />
            <input #maxFinanziamento id="maxFinanziamento" type="number" class="form-control price-label"
              placeholder="A" (focus)="this.onFocusInput(2)"
              (change)="this.changeValue($event.target.value, 'maxFinanziamento')" />
          </div>
          <ul class="text-start list-unstyled" [style.display]="this.listRange == 1 ? 'block' : 'none'">
            <li (click)="this.setFilter('minFinanziamento', null, 2, maxFinanziamento)">Nessun limite</li>
            <ng-container *ngFor="let minP of this.optionsFinanziamento">
              <li (click)="this.setFilter('minFinanziamento', minP, 2, maxFinanziamento)">{{
                minP |
                currencyITFormat:'EUR':'€':"1.0-2"
                }}
              </li>
            </ng-container>
          </ul>
          <ul class="text-end list-unstyled" [style.display]="this.listRange == 2 ? 'block' : 'none'">
            <li (click)="this.setFilter('maxFinanziamento', null, null, null)">Nessun limite</li>
            <ng-container *ngFor="let maxP of this.optionsFinanziamento">
              <li *ngIf="!this.main?.filtersList?.minFinanziamento || maxP >= this.main?.filtersList?.minFinanziamento"
                (click)="this.setFilter('maxFinanziamento', maxP, null, null)">{{
                maxP |
                currencyITFormat:'EUR':'€':"1.0-2"
                }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO ESCLUSIVA -->
    <div [class.d-block]="this.showFilters" class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.exclusive">
      <label for="exclusive" class="btn single-checkbox-filter fw-normal cursor-pointer m-0" data-toggle="tooltip"
        title=""
        [tooltip]="'Attivando questo filtro vedrai solo gli annunci di immobili con un incarico in esclusiva attivo da parte del mediatore'">
        <p class="checkbox-title">Incarico in esclusiva</p>
        <input type="checkbox" class="me-2" id="exclusive" (change)="this.handleExlusivityInput()"
          [checked]="this.main?.filtersList.exclusive">
      </label>
    </div>

    <!-- PIù FILTRI -->
    <div [class.d-block]="this.showFilters" class="col-lg-4 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.exclusive">
      <button (click)="showMoreFilters()" class="btn btn-more-filter text-primary">
        <i class="icon-filter me-1"></i>
        Più filtri
      </button>
    </div>

    <!-- RIMUOVI FILTRI -->
    <div *ngIf="this.main?.countFilters() > 0" [class.d-flex]="this.showFilters"
      class="col-lg-4 col-md-6 col-sm-12 py-2 removeFiltersCont  d-md-flex justify-content-between align-items-center">
      <button class="btn btn-remove-filters text-danger" (click)="this.removeFilters()">
        <i class="icon-trash-alt-solid me-1"></i> Rimuovi filtri
        <span class="filter-pill">{{ this.main?.countFilters() }}</span>
      </button>
    </div>
  </div>

</ng-container>
<ng-container *ngIf="(this.main?.searchType == 'agente') && !this.isHome && !this.is404">
  <div class="row align-items-center" [class.justify-content-between]="this.main.isAgentSearch">
    <!-- FILTRO ORDINA ATTIVITA -->
    <div *ngIf="this.main.isAgentSearch" [class.d-block]="this.showFilters "
      class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.orderList.activities">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button textCapitalize" (click)="this.openDrodown('activities')"
          [innerHTML]="this.showActivitiesLabel(this.main?.orderList.activities)"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'activities' ? 'block' : 'none'">
          <ul class="text-start list-unstyled list-unstyled-checkbox">
            <li>
              <label for="tutte-attività"
                class="w-100 h-100 d-flex align-items-start justify-content-start m-0 py-2 association-container">
                <input type="radio" name="activities" id="tutte-attività" value="" class="me-2"
                  (change)="changeActivitiesStatus('Tutte le attività', false)"
                  [checked]="this.main?.orderList.activities===''">
                <span>Tutte le attività</span>
              </label>
            </li>
            <ng-container *ngFor="let activity of this.activities; let i = index">
              <li>
                <label [for]="activity.value"
                  class="w-100 h-100 d-flex align-items-start justify-content-start m-0 py-2 association-container">
                  <input type="radio" name="activities" [id]="activity.value" [value]="activity.orderName" class="me-2"
                    (change)="changeActivitiesStatus(activity.value, true)"
                    [checked]="this.main?.orderList.activities===activity.value">
                  <ng-container
                    *ngIf="activity.name !== 'property_finder' || activity.name !== 'mutui_e_prestiti';else showAlternativeSpan">
                    <span>{{
                      activity.name | titlecase
                      }}</span>
                  </ng-container>
                  <ng-template #showAlternativeSpan>
                    <span>{{
                      activity.name === 'property-finder' ? 'Property finder' : 'Mutui e prestiti'
                      }}</span>
                  </ng-template>
                </label>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>

    <!-- FILTRO SPECIALIZZAZIONI *ngIf="this.isAgentSearch"-->
    <div [class.d-block]="this.showFilters" class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.specializations && this.main?.filtersList?.specializations.length">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('specializations')"
          [innerHTML]="this.showSpecializationsLabel()"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'specializations' ? 'block' : 'none'">
          <ul class="text-start list-unstyled list-unstyled-checkbox">
            <ng-container *ngIf="this.main.isAgentSearch; else professionistSpec">
              <ng-container *ngFor="let specialization of this.main?.specializations">
                <li>
                  <label [for]="'specializzazione'+specialization"
                    class="w-100 h-100 d-flex align-items-start justify-content-start m-0 py-2 association-container">
                    <input type="checkbox" [name]="'specializzazione'+specialization.id"
                      [id]="'specializzazione'+specialization.id" class="me-2"
                      (change)="changeSpecializationsStatus(specialization.id, $event)"
                      [checked]="this.checkChekbox(specialization.id, this.main?.filtersList.specializations)">
                    <span>{{ specialization.name | titlecase }}</span>
                  </label>
                </li>
              </ng-container>
            </ng-container>
            <ng-template #professionistSpec>
              <ng-container *ngFor="let specialization of this.main?.specializationsProfessionists">
                <li>
                  <label [for]="'specializzazione'+specialization"
                    class="w-100 h-100 d-flex align-items-start justify-content-start m-0 py-2 association-container">
                    <input type="checkbox" [name]="'specializzazione'+specialization.id"
                      [id]="'specializzazione'+specialization.id" class="me-2"
                      (change)="changeSpecializationsStatus(specialization.id, $event)"
                      [checked]="this.checkChekbox(specialization.id, this.main?.filtersList.specializations)">
                    <span>{{ specialization.name | titlecase }}</span>
                  </label>
                </li>
              </ng-container>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO LINGUE -->
    <div [class.d-block]="this.showFilters" class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.languages && this.main?.filtersList?.languages.length">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('languages')"
          [innerHTML]="this.showLanguagesLabel()"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'languages' ? 'block' : 'none'">
          <ul class="text-start list-unstyled list-unstyled-checkbox">
            <ng-container *ngFor="let lang of this.main?.languages">
              <li>
                <label [for]="lang"
                  class="w-100 h-100 d-flex align-items-start justify-content-start m-0 py-2 association-container">
                  <input type="checkbox" [name]="lang" [id]="lang" class="me-2"
                    (change)="changeLanguagesStatus(lang, $event)"
                    [checked]="this.checkChekbox(lang, this.main?.filtersList.languages)">
                  <span>{{ lang | titlecase }}</span>
                </label>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO ANNI DI ESPERIENZA -->
    <div [class.d-block]="this.showFilters" class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.minExp || this.main?.filtersList?.maxExp">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('experience', minExp)"
          [innerHTML]="this.showExpLabel(this.main?.filtersList?.minExp, this.main?.filtersList?.maxExp)"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'experience' ? 'block' : 'none'">
          <div class="dropdown-range-input">
            <input #minExp id="minExp" type="number" class="form-control price-label" placeholder="Da"
              (focus)="this.onFocusInput(1)" (change)="this.changeValue($event.target.value, 'minExp')" />
            <input #maxExp id="maxExp" type="number" class="form-control price-label" placeholder="A"
              (focus)="this.onFocusInput(2)" (change)="this.changeValue($event.target.value, 'maxExp')" />
          </div>
          <ul class="text-start list-unstyled" [style.display]="this.listRange == 1 ? 'block' : 'none'">
            <li (click)="this.setFilter('minExp', null, 2, maxExp)">Nessun limite</li>
            <ng-container *ngFor="let minP of this.optionsExp">
              <li (click)="this.setFilter('minExp', minP, 2, maxExp)">{{ minP }}</li>
            </ng-container>
          </ul>
          <ul class="text-end list-unstyled" [style.display]="this.listRange == 2 ? 'block' : 'none'">
            <li (click)="this.setFilter('maxExp', null, null, null)">Nessun limite</li>
            <ng-container *ngFor="let maxP of this.optionsExp">
              <li *ngIf="!this.main?.filtersList?.minExp || maxP >= this.main?.filtersList?.minExp"
                (click)="this.setFilter('maxExp', maxP, null, null)">{{ maxP }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO MANDATO -->
    <div *ngIf="this.main.isAgentSearch" [class.d-block]="this.showFilters"
      class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.mandates && this.main?.filtersList?.mandates.length">
      <div class="dropdown dropdown-filter-range">
        <button class="btn dropdown-button" (click)="this.openDrodown('mandate')"
          [innerHTML]="this.showMandatesLabel()"></button>
        <div class="dropdown-range" [style.display]="this.idDropdownOpen == 'mandate' ? 'block' : 'none'">
          <ul class="text-start list-unstyled list-unstyled-checkbox">
            <ng-container *ngFor="let mandate of this.main?.mandates">
              <li>
                <label [for]="mandate.name"
                  class="w-100 h-100 d-flex align-items-start justify-content-start m-0 py-2 association-container">
                  <input type="checkbox" [name]="mandate.id" [id]="mandate.id" class="me-2"
                    (change)="changeMandatesStatus(mandate.id, $event)"
                    [checked]="this.checkChekbox(mandate.id, this.main?.filtersList.mandates)">
                  <span>{{ mandate.name | titlecase }}</span>
                </label>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <!-- FILTRO OPPORTUNITA -->
    <div *ngIf="this.main.isAgentSearch" [class.d-block]="this.showFilters"
      class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.opportunity"
      [tooltip]="'Cerca tutti i consulenti ed agenti che attualmente non lavorano con agenzie e che sono disponibili a valutare nuove proposte lavorative'">
      <label for="opportunity" class="btn single-checkbox-filter fw-normal cursor-pointer m-0">
        <p class="checkbox-title">In cerca di opportunità</p>
        <!-- <input type="checkbox" class="me-2" id="opportunity" (change)="this.main?.filtersList.opportunity=!this.main?.filtersList.opportunity" [checked]="this.main?.filtersList.opportunity"> -->
        <input type="checkbox" class="me-2" id="opportunity" (change)="handleOpportunityFilters('opportunity')"
          [checked]="this.main?.filtersList.opportunity">
      </label>
    </div>

    <!-- FILTRO OPPORTUNITA -->
    <div *ngIf="this.main.isAgentSearch" [class.d-block]="this.showFilters"
      class="col-lg-3 col-md-6 col-sm-12 py-2 filtersAnnuncio d-md-block"
      [class.active]="this.main?.filtersList?.collab"
      [tooltip]="'Vedi tutti gli agenti che sono favorevoli alla collaborazione tra agenti'">
      <label for="collab" class="btn single-checkbox-filter fw-normal cursor-pointer m-0">
        <p class="checkbox-title">Collaborazione tra agenti</p>
        <!-- <input type="checkbox" class="me-2" id="collab" (change)="this.main?.filtersList.collab=!this.main?.filtersList.collab" [checked]="this.main?.filtersList.collab"> -->
        <input type="checkbox" class="me-2" id="collab" (change)="handleOpportunityFilters('collab')"
          [checked]="this.main?.filtersList.collab">
      </label>
    </div>

    <div [class.d-flex]="this.showFilters"
      class="col-lg-3 col-md-6 col-sm-12 py-2 removeFiltersCont d-md-flex justify-content-end align-items-center"
      [class.col-md-]="this.main?.searchType === 'agenzia'">
      <!-- [disabled]="this.disableRemoveFilters()" -->
      <button *ngIf="this.main?.countFilters() > 0" class="btn btn-remove-filters text-danger"
        (click)="this.removeFilters()"
        [class.disabled]="this.main?.returnFilter().length == 0 && this.activitiesSelected === '' ">
        <i class="icon-trash-alt-solid me-1"></i>
        Rimuovi filtri
        <span class="filter-pill">{{ this.main?.countFilters() }}</span>
      </button>
    </div>
  </div>
</ng-container>

<ng-container
  *ngIf="(this.main?.searchType == 'vendita' || this.main?.searchType == 'affitto' || this.main?.searchType == 'agente' || this.main?.searchType == 'agenzia') && !this.isHome && !this.is404">
  <div class="col-sm-12 d-xl-none d-lg-none d-md-none">
    <div class="filterAndSaveCont d-flex my-1 py-4">
      <div class="filterAndSaveCont__item d-flex px-2 py-1" *ngIf="this.main?.searchType!=='agenzia'">
        <ng-container *ngIf="!this.showFilters;else sortDownIcon">
          <i class="icon-chevron-down ms-2"></i>
        </ng-container>
        <ng-template #sortDownIcon>
          <i class="icon-chevron-up"></i>
        </ng-template>
        <p (click)="handleShowFilters()" class="mb-0 ps-2 fw-normal">Mostra filtri</p>
      </div>

      <div *ngIf="!this.isSaved && !this.isWhiteLabel" (click)="this.saveSearches()"
        class="filterAndSaveCont__item d-flex px-2 py-1">
        <i class="icon-search-plus"></i>
        <p class="mb-0 ps-2 fw-normal">Salva ricerca</p>
      </div>
    </div>
  </div>
</ng-container>

<app-popup-ateco [agentFullName]="atecoAgentFullName" [esponenteName]="this.esponenteName" [objType]="this.atecoType"
  [atecoCompanyObj]="atecoObj" (closePopupAtecoEvt)="this.closeAtecoPopup()"
  [popupAtecoIsOpen]="this.popupAtecoIsOpen"></app-popup-ateco>